export const FAQ = [
  {
    question: "درباره تارا بیشتر توضیح میدین؟",
    answer:
      "تارا اپلیکیشن خرید اعتباری که در کمتر از ۱۰ دقیقه بهتون اعتبار میده و می‌تونید با اعتبارتون از هزاران فروشگاه به صورت اقساطی خرید کنید. خرید با اعتبار تارا بدون سود، کارمزد و پیش پرداخته و تجربه متفاوتی از خرید اعتباری رو براتون خلق می‌کنه.",
  },
  {
    question: "اعتبار سه قسطه تارا چیه؟",
    answer:
      "این اعتبار، اعتبار اختصاصی خرید از بانی‌مده که با فعال‌سازی و استفاده از این سرویس اعتباری می‌تونید در بانی‌مد، از هر برندی که دوست دارید، در ۳ قسط و بدون پیش پرداخت خرید کرده و اقساط رو در ابتدای هر ماه پرداخت کنید.",
  },
  {
    question: "چه کسانی می‌تونن اعتبار سه قسطه تارا دریافت کنند؟",
    answer:
      "این سرویس در بازه زمانی بلک فرایدی برای کاربران تارا و بانی‌مد فعاله. برای دریافت اعتبار سه قسطه در این بازه زمانی، کافیه شماره همراه‌تون رو در همین صفحه وارد کنید. اگر قبلا اعتبار دو قسطه تارا داشتید، بدون نیاز به احراز هویت و اعتبارسنجی می‌تونید خیلی سریع و راحت اعتبار سه قسطه بگیرید. اگر قبلا اعتبار تارا نداشتید، کافیه تارا رو نصب کنید و با احراز هویت و اعتبارسنجی در کمتر از ۱۰ دقیقه اعتبارتون رو بگیرید.",
  },
  {
    question: "چطور می‌تونم اعتبار سه قسطه تارا رو بگیرم؟",
    answer:
      "برای دریافت اعتبار سه قسطه تارا، شماره موبایل‌تون رو در همین صفحه وارد کنید تا بلافاصله اعتبار سه قسطه شما رو فعال کنیم. ممکنه در حال حاضر اعتبار سه قسطه برای شما فعال باشه. کافیه در اپ تارا کارت سه قسطه رو ببینید.",
  },
];
